import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: {},
  loading: false,
}

export const LoginCheckSlice = createSlice({
  name: 'LoginCheck',
  initialState,
  reducers: {
    Login_Check_request: (state, action) => {
      state.value = {};
      state.loading = true;
    },
    Login_Check_success: (state, action) => {

      state.value = action.payload;
      state.loading = false;
      state.error = {};

    },
    Login_Check_failure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.value = {};
    },
    Clear_Login_Check: (state, action) => {
      state.value = {}
      state.error = {};
      state.loading = false;
    },
  }
})

// Action creators are generated for each case reducer function
export const { Login_Check_request, Login_Check_success, Login_Check_failure, Clear_Login_Check } = LoginCheckSlice.actions

export default LoginCheckSlice.reducer